import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import giftActions from '../actions/gift'

export const useGift = () => {
  const data = useSelector((state) => {
    return get(state, 'app.giftManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(giftActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
